export default class PetConcern {}

PetConcern.FleaAndTick = 'FLEA_AND_TICK';
PetConcern.Skin = 'SKIN';
/*
 * @deprecated
 */
PetConcern.SkinAndEar = 'SKIN_AND_EAR_INFECTIONS';
